import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpHelperService } from "src/app/shared/services/http-helper.service";
import { SKIP_LOADING_HEADER } from "src/app/shared/services/loading-interceptor/loading-interceptor.service";

const SKIP_LOADING_JSON_HEADERS = new HttpHeaders({
  "Content-Type": "application/json",
  [SKIP_LOADING_HEADER]: "1",
});

@Injectable()
export class NotificationService {
  constructor(private readonly httpHelperService: HttpHelperService) {}

  public notificationList(body): Observable<any> {
    return this.httpHelperService.post(
      "/notification/list",
      body,
      SKIP_LOADING_JSON_HEADERS,
    );
  }

  public sendReadNotification(payload: any): Observable<any> {
    return this.httpHelperService.post(
      `/notification/save`,
      payload,
      SKIP_LOADING_JSON_HEADERS,
    );
  }

  public getNotificationDetails(payload): Observable<any> {
    return this.httpHelperService.get(
      `/notification/detail?id=${payload.notificationId}&userId=${payload.userId}`,
    );
  }
}
